import { Flex, Input } from 'antd';
import { SearchOutlined } from '@ant-design/icons';

export default function SearchChatFilter({ value, onChange }) {
    return (
        <Flex align='center' justify='space-between' style={{ marginBottom: 16 }} gap={12}>
            <Input
                size='medium'
                placeholder="Search"
                prefix={<SearchOutlined />}
                value={value}
                onChange={onChange}
            />
        </Flex>
    );
}

